import { useQuery } from "@tanstack/react-query";
import giftCategoriesClient, {
  PendulumLogo,
} from "../../../../api/giftCategories";

const useLogosQuery = () => {
  return useQuery<PendulumLogo[]>({
    queryKey: ["logos"],
    queryFn: () => giftCategoriesClient.getLogos(),
  });
};

export default useLogosQuery;
